import { features } from '@/api';
import * as types from '../../mutationTypes';

export default {
  async getFeatures({ commit }, featureNames) {
    try {
      const response = await features.getFeatures(featureNames);
      if (response?.status === 200 && response?.data) {
        commit(types.SET_FEATURES, response.data);
      }
    } catch (error) {
      console.log('Get Feature Flags Error: ', error.message);
    }
  }
};
